import { render, staticRenderFns } from "./SocialLoginSuccess.vue?vue&type=template&id=25e855ba&scoped=true"
import script from "./SocialLoginSuccess.vue?vue&type=script&lang=js"
export * from "./SocialLoginSuccess.vue?vue&type=script&lang=js"
import style0 from "./SocialLoginSuccess.vue?vue&type=style&index=0&id=25e855ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e855ba",
  null
  
)

export default component.exports